import list from '@/store/modules/storage/matches/list';
import matches from '@/store/modules/storage/matches/matches';

export default {
    list,
    matches,
};
